import script from "./Config.vue?vue&type=script&setup=true&lang=js"
export * from "./Config.vue?vue&type=script&setup=true&lang=js"

import "./Config.vue?vue&type=style&index=0&id=7467f8c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7467f8c5"]])

export default __exports__